
export const ICON_KNOWLEDGE_BASE_ARTICLE = 'ICON_KNOWLEDGE_BASE_ARTICLE';
export const ICON_KNOWLEDGE_BASE_CATEGORY = 'ICON_KNOWLEDGE_BASE_CATEGORY';

export const KNOWLEDGE_BASE_ICONS = [ICON_KNOWLEDGE_BASE_ARTICLE, ICON_KNOWLEDGE_BASE_CATEGORY];

export const LINK_ICONS = {
    [ICON_KNOWLEDGE_BASE_CATEGORY]: 'bi bi-journal-bookmark-fill',
    [ICON_KNOWLEDGE_BASE_ARTICLE]: 'bi bi-journal-richtext',
    '': 'bi bi-link-45deg',
};

export const TYPE_MESSAGE = 'MESSAGE';
export const MESSAGE_ORIGIN_CUSTOMER = 'CUSTOMER';
export const MESSAGE_ORIGIN_EMPLOYEE = 'EMPLOYEE';

export const DEFAULT_USER_MESSAGE = {
    id: null,
    chat_id: null,
    content: '',
    type: TYPE_MESSAGE,
    origin: MESSAGE_ORIGIN_CUSTOMER,
    date: null,
    is_read: true,
    attachments: [],
};
